<template>
  <responsive-modal v-model="visible" title="Integrar Digital Manager Guru">
    <div class="tool-modal-digital-manager-guru">
      <a
        href="https://digitalmanager.guru/"
        target="_blank"
        class="integration-link"
      >
        Conheça a Digital Manager Guru
        <i class="ph ph-arrow-square-out" />
      </a>
      <snow-select
        v-model="form.product_id"
        id="product-select"
        label="Produto"
        :disabled="isEdit"
        :errors="errors.product_id"
        :options="products.map(({ id, name }) => ({ id, name }))"
      />
      <snow-input
        v-model="form.description"
        id="description"
        label="Descrição da integração (Opcional)"
      />
      <snow-input
        v-model="form.internal_id"
        id="internal_id"
        label="ID externo"
        :rules="rules.internal_id"
      />
      <snow-input
        v-model="form.token"
        id="token"
        label="Token"
        :rules="rules.token"
      />
      <snow-input
        label="Url externa"
        id="external_url"
        type="text"
        v-model="form.url"
        :rules="rules.url"
      />
      <div class="snow-submit-buttons">
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="
            visible = false;
            clear();
          "
        />
        <snow-button
          size="lg"
          text="Salvar"
          :disabled="!isValid"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
import { required, validUrl } from "@/functions/validation";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields([
        "product_id",
        "url",
        "status",
        "description",
        "internal_id",
        "name"
      ]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    }
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("product/get", { limit: 500 })
      .then()
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return (
        this.form.internal_id &&
        this.form.product_id &&
        this.form.url &&
        this.form.token
      );
    },
    isEdit() {
      return !!this.integrationToEdit?.id;
    },
    rules() {
      return {
        url: [required(), validUrl()],
        token: [required()],
        internal_id: [required()]
      };
    }
  },
  methods: {
    clear() {
      this.form = { name: "digital-manager-guru" };
      this.$emit("clear-edit");
    },
    submit() {
      if (this.loading) return;

      this.loading = true;
      let data = { ...this.form };

      let action = "integration/postIntegration";
      if (this.integrationToEdit?.id) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }
      this.$store
        .dispatch(action, data)
        .then(() => {
          this.loading = false;
          this.visible = false;
          this.$emit("update-list");
          this.clear();
          this.$message.success("A integração foi salva!");
        })
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar configuração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-digital-manager-guru {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
